<app-common-modal-form
  header="View and Send"
  icon="ic-send-20"
  [isCustomFooter]="true"
  (close)="close()"
>
  <div class="body-container d-flex gap-24" [formGroup]="form">
    @if (!isSendLoading()) {
      <div class="sent-container d-flex flex-column gap-24">
        <div>
          <app-radio
            formControlName="sendBy"
            label="Send by"
            [options]="sendByOptions"
          />
        </div>

        <app-divider/>

        <div class="documents-container">
          <div class="sub-title">Documents</div>

          <div>
            @for (document of (documentsList$ | async)?.final; track document) {
              <app-file-label
                [hideDeleteBtn]="true"
                (downloadFile)="downloadFile(document.name, 'final')"
              >
                {{ document.name }}
              </app-file-label>
            } @empty {
              <div>No files</div>
            }
          </div>
        </div>

        <div class="documents-container">
          <div class="sub-title">Templates</div>
          <div>
            @if (selectedEmailTemplateName) {
              <app-file-label
                [hideDeleteBtn]="true"
                [hideDownloadBtn]="true"
              >
                {{ selectedEmailTemplateName }}
              </app-file-label>
            }

            @for (data of annual?.changes; track $index) {
              <app-file-label
                [hideDeleteBtn]="true"
                [hideDownloadBtn]="true"
              >
                {{ data.coverLetterName ? (data.coverLetterName + ' (Cover Letter)') : defaultCoverLetterTemplateName }}
              </app-file-label>
            }

            @if (!annual?.changes?.length && !selectedEmailTemplateName) {
              <div>No templates</div>
            }
          </div>
        </div>

        @if (partnerManagerName) {
          <div class="documents-container">
            <div class="sub-title">Partner</div>
            <span class="font-size-12 font-weight-400 line-height-20">{{ partnerManagerName }}</span>
          </div>
        }

        @if (this.form.controls.sendBy.value === SendOption.Sign) {
          <div class="documents-container">
            <div class="sub-title">Recipients</div>

            @if (isContactsLoading()) {
              <div>
                <ngx-skeleton-loader count="4" appearance="line"/>
              </div>
            } @else {
              <ul class="list-unstyled mb-0">

                @for (director of companyDirectors; track director) {
                  <li>
                    <div class="form-group">
                      <div class="font-size-12 font-weight-400 color-gray-900">
                        {{ director.individualDataOverride?.fullName ?? '' }}
                      </div>

                      <app-contacts-select
                        label=""
                        [formControl]="contactsFormArray.controls[$index]"
                        [contacts]="director.individualId && directorsContacts[director.individualId] ? directorsContacts[director.individualId] : []"
                        [allowAddNoRelationshipNewContact]="false"
                        [entityId]="annual?.company?.entityId ?? ''"
                        [newContactRelationshipId]="director.relationshipId"
                        (contactCreated)="onContactCreated($event)"
                        (select)="onDirectorContactSelected(director.individualId, $event)"
                      />

                      @if (contactsFormArray.controls[$index].valid
                            && director.individualId
                            && !directorsSelectedContacts[director.individualId]?.email) {
                        <div class="color-red font-size-12 font-weight-400 line-height-16">
                          {{ contactWithEmailRequiredMessage }}
                        </div>
                      }
                    </div>
                  </li>
                }
              </ul>
            }
          </div>
        } @else {
          <app-multiple-input-email
            label="To"
            placeholder="Enter email"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="emailList"
          />
        }
      </div>
    } @else {
      <div class="skeleton-container">
        <div class="mb-4">
          <ngx-skeleton-loader count="1" appearance="line"/>
        </div>
        <div class="mb-4">
          <ngx-skeleton-loader count="8" appearance="line"/>
        </div>
        <div class="mb-4">
          <ngx-skeleton-loader count="6" appearance="line"/>
        </div>
        <div class="mb-4">
          <ngx-skeleton-loader count="4" appearance="line"/>
        </div>
      </div>
    }

    @if (!isAnnualLoading() && !isSendLoading()) {
      <div class="preview-container">
        <app-email-preview
          [sendByMethod]="form.controls.sendBy.value"
          [documentBase]="annual!"
          [isDocument]="false"
          [previewMode]="true"
          (changeEmail)="changeEmail($event)"
        />
      </div>
    } @else {
      <div class="skeleton-container">
        <div class="mb-4">
          <ngx-skeleton-loader count="1" appearance="line"/>
        </div>
        <div class="mb-4">
          <ngx-skeleton-loader count="20" appearance="line"/>
        </div>
      </div>
    }
  </div>

  <div class="custom-footer d-flex gap-24">
    <button
      type="button"
      class="btn btn-primary d-flex align-items-center gap-2"
      [class.btn-loading]="isSendLoading()"
      [disabled]="isNotValidForSend || isSendLoading()"
      (click)="send()"
    >
      <i class="icon ic-send-20"></i>
      <span>Send</span>
    </button>

    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-2"
      [disabled]="isSendLoading()"
      (click)="customize()"
    >
      <i class="icon ic-edit-20"></i>
      <span>Customise</span>
    </button>

    <app-divider [vertical]="true"/>

    <button
      type="button"
      class="btn btn-secondary"
      (click)="close()"
    >
      Cancel
    </button>
  </div>
</app-common-modal-form>
